







import VueOptions from '@utils/VueOptions'

settings =
  name: 'RequestButton'
  vue:
    props: ['type', 'onClick', 'label', 'disabled']
    computed:
      buttonType: -> @type || 'primary'
      isLoading: -> @clicked && @requestIsPending
    data: ->
      clicked: false
    updated: ->
      if (!@requestIsPending)
        @clicked = false
    methods:
      hiRequest: ->
        @clicked = true
        @onClick() if @onClick

export default VueOptions.vue settings
